import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { TableRow, TableCell, Avatar, Button, ListItemText, Tooltip, Box, IconButton, Collapse, Stack, Paper, Typography } from "@mui/material";
import { usePopover } from '../../../../components/custom-popover/index.js';
import Iconify from "../../../../components/iconify/iconify.js";
import { useSnackbar } from '../../../../components/snackbar/index.js';
import Label from '../../../../components/label/index.js';
import AttendanceDialog from './class-attendance-dialog.js';
import { useBoolean } from '../../../../hooks/use-boolean.js';
import { useLocation } from 'react-router-dom';
import { courseMode } from 'src/util/course.js';
import { CREATE_ATTENDANCE, CREATE_E_SIGNATURE } from "../../../../graphql/modules/_client/attendance.js";
import { useMutation } from "@apollo/react-hooks";
import ESignature from '../../../../util/eSignature.jsx';

const defaultvalue = {
  attendance: '1',
  surveyLanguage: 'EL',
  numberOfHours: null
}

export default function ClassAttendanceRow({ row, index, trainee, selected, courseRunId, uen, courseReferenceNumber, onSelected, onSubmitAttendance, onEditRow, onViewRow, onSelectRow, classinfo }) {
  const companyProfile = useSelector((state) => state?.auth?.companyProfile?.companyProfile);
  const { nricFin } = useSelector((state) => state?.auth?.user);
  const { fullName } = useSelector((state) => state?.auth?.user);
  const company = useSelector((state) => state?.auth?.company);
  const { state } = useLocation();
  const isRole = useSelector((state) => state?.auth?.isRole);
  const [userInfo, setUserInfo] = useState(null);
  const [sessionNo, setSessionNo] = useState(null);
  const [attendanceValue, setAttendanceValue] = useState(null);
  // const [attendanceStatus] = useState('1');
  // const [attendanceSurvey] = useState('EL');
  const [surveryValue, setSurvey] = useState(defaultvalue);
  const { enqueueSnackbar } = useSnackbar();
  const [signature, setSignature] = useState(null);

  const sessionNorow = index;
  const { endDate, endTime, id, modeOfTraining, startDate, startTime } = row;
  const [CreateAttendanceMutation] = useMutation(CREATE_ATTENDANCE);
  const [AddESignatureMutation] = useMutation(CREATE_E_SIGNATURE);

  const popover = usePopover();
  const attendance = useBoolean();
  const collapse = useBoolean();

  const eSign = useBoolean();

  const modeOfTrainingValue = courseMode?.map((result) => {
    if (result.id === modeOfTraining) {
      return result?.value
    }
  })

  const handleSaveAttendance = async () => {
    const { data: { createAttendance } } = await CreateAttendanceMutation({
      variables: {
        uen: uen,
        corppassId: nricFin,
        courseRunId: courseRunId,
        encryptionkey: companyProfile?.encryptionKey,
        _companyName: companyProfile?.companyName,
        companyName: companyProfile?.databaseName || company,
        data: {
          course: {
            courseReferenceNumber: courseReferenceNumber,
            sessionID: id,
            attendance: surveryValue?.attendance
          },
          userInfo: userInfo,
          surveyLanguage: surveryValue?.surveyLanguage,
          numberOfHours: Number(parseFloat(surveryValue?.numberOfHours).toFixed(1))
        }
      }
    });


    if (createAttendance?.success) {
      enqueueSnackbar("Submitted successfully!", { variant: "success" });
    } else {
      enqueueSnackbar(createAttendance?.message, { variant: "error" });
    }

  }


  const handleESignature = async () => {
    const { data: { addESignature } } = await AddESignatureMutation({
      variables: {
        companyName: companyProfile?.databaseName || company,
        fullName: fullName,
        _id: classinfo?._id,
        traineeID: userInfo?._id,
        data: {
          eSignature: {
            eSign: signature,
            dateCaptured: Date.now(),
            sessionDate: startDate,
            startTime: startTime,
            endTime: endTime,
            sessionNo: sessionNo
          }
        }
      }
    });


    if (addESignature?.success) {
      enqueueSnackbar("Submitted successfully!", { variant: "success" });
    } else {
      enqueueSnackbar(addESignature?.message, { variant: "error" });
    }

  }

  const addEnrolmentStatus = trainee?.map(obj => {
    const enrolStatus = row?.attendance?.find(item => item?.nric === obj?.traineeInfo?.nricFin);
    if (enrolStatus) {
      return ({
        name: enrolStatus?.trainee?.name,
        id: enrolStatus?.trainee?.id,
        status: enrolStatus?.status,
        enrolmentStatus: obj?.ssgenrolment?.status,
        idType: {
          code: enrolStatus?.trainee?.idType?.code
        },
        "email": obj?.traineeInfo?.email,
        "contactNumber": {
          "countryCode": "65",
          "areaCode": "0",
          "mobile": obj?.traineeInfo?.mobileNo
        },
      })
    }
    return null;

  }).filter(item => item !== null)

  const trainer = row?.attendance && row?.attendance?.find(item => item?.trainee?.attendeeType === "Trainer");



  const getUnSubmittedAttendance = trainee?.filter(a => !row?.attendance?.find(p => p.nric === a?.traineeInfo?.nricFin))
  const renderPrimary = (
    <TableRow hover selected={selected}>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{id}</TableCell>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{modeOfTrainingValue}</TableCell>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{startDate}</TableCell>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{startTime}</TableCell>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{endDate}</TableCell>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{endTime}</TableCell>


      <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
        <IconButton
          color={collapse.value ? 'inherit' : 'default'}
          onClick={collapse.onToggle}
          sx={{
            ...(collapse.value && {
              bgcolor: 'action.hover',
            }),
          }}
        >
          <Iconify icon="eva:arrow-ios-downward-fill" />
        </IconButton>

      </TableCell>

    </TableRow>
  )

  const secondaryPrimary = (
    <TableRow>
      <TableCell sx={{ p: 0, border: 'none' }} colSpan={8}>
        <Collapse
          in={collapse.value}
          timeout="auto"
          unmountOnExit
          sx={{ bgcolor: 'background.neutral' }}
        >
                    <Stack component={Paper} sx={{ m: 1.5 }}>
                <Stack
                key={trainer?.id}
                direction="row"
                alignItems="center"
                sx={{
                  p: (theme) => theme.spacing(1.5, 2, 1.5, 1.5),
                  '&:not(:last-of-type)': {
                    borderBottom: (theme) => `solid 2px ${theme.palette.background.neutral}`,
                  },
                }}
              >
                <Avatar
                  src={""}
                  variant="rounded"
                  sx={{ width: 48, height: 48, mr: 2 }}
                />
            <ListItemText
                  primary={<>
                    <Label
                    variant="filled"
                    color={'info'}
                  >
                    {trainer?.trainee?.attendeeType}
                  </Label>
                  <br/>
                  {trainer?.trainee?.name}
                  </>}
                  secondary={trainer?.trainee?.id}
                  primaryTypographyProps={{
                    typography: 'body2',
                  }}
                  secondaryTypographyProps={{
                    color: 'text.disabled',
                    mt: 0.5,
                  }}
                />


                <Box sx={{ textAlign: 'left', marginLeft: '10px' }}>
                  <Label
                    variant="soft"
                    color={
                      (trainer?.status === 'Confirmed' && 'success') ||
                      (trainer?.status === 'Cancelled' && 'error') ||
                      (trainer?.status === 'Draft' && 'warning') ||
                      'default'
                    }
                  >
                    {trainer?.status === 'Confirmed' ? 'Attendance Confirmed' : trainer?.status === 'Cancelled' ? 'Attendance Cancelled' : trainer?.status}
                  </Label>
                </Box>
                

                </Stack>
          </Stack>

          <Stack component={Paper} sx={{ m: 1.5 }}>
            {addEnrolmentStatus?.sort((a, b) => a?.name.localeCompare(b?.name)).map((item) => (
              <Stack
                key={item?.id}
                direction="row"
                alignItems="center"
                sx={{
                  p: (theme) => theme.spacing(1.5, 2, 1.5, 1.5),
                  '&:not(:last-of-type)': {
                    borderBottom: (theme) => `solid 2px ${theme.palette.background.neutral}`,
                  },
                }}
              >
                <Avatar
                  src={""}
                  variant="rounded"
                  sx={{ width: 48, height: 48, mr: 2 }}
                />

                <ListItemText
                  primary={item?.name}
                  secondary={item?.id}
                  primaryTypographyProps={{
                    typography: 'body2',
                  }}
                  secondaryTypographyProps={{
                    color: 'text.disabled',
                    mt: 0.5,
                  }}
                />
                <Box sx={{ textAlign: 'left' }}>
                  <Label
                    variant="soft"
                    color={
                      (item?.enrolmentStatus === 'Confirmed' && 'success') ||
                      (item?.enrolmentStatus === 'Cancelled' && 'error') ||
                      (item?.enrolmentStatus === 'Draft' && 'warning') ||
                      'default'
                    }
                  >
                    {item?.enrolmentStatus === 'Confirmed' ? 'Enrolment Confirmed' : item?.enrolmentStatus === 'Cancelled' ? 'Enrolment Cancelled' : item?.enrolmentStatus}
                  </Label>
                </Box>

                <Box sx={{ textAlign: 'left', marginLeft: '10px' }}>
                  <Label
                    variant="soft"
                    color={
                      (item?.status === 'Confirmed' && 'success') ||
                      (item?.status === 'Cancelled' && 'error') ||
                      (item?.status === 'Draft' && 'warning') ||
                      'default'
                    }
                  >
                    {item?.status === 'Confirmed' ? 'Attendance Confirmed' : item?.status === 'Cancelled' ? 'Attendance Cancelled' : item?.status}
                  </Label>
                </Box>


                {/* <Box sx={{ width: 110, textAlign: 'right',  display: isRole?.some((role)=> ["tm"].includes(role)) ?  '' : 'none'}} >
                           <Tooltip title="Add Attendance">
                             <IconButton color={popover.open ? 'inherit' : 'default'} onClick={() => {
                                setUserInfo(item?.traineeInfo);
                                setSessionNo(sessionNorow);
                                eSign.onTrue()
                             }}
                             sx={{
                               display: item?.ssgenrolment?.status === 'Cancelled' ? 'none' : ''
                             }}
                             >
                                 <Iconify icon="solar:pen-bold" />
                             </IconButton>
                             </Tooltip>
                         </Box> */}

                {/* <Box sx={{ width: 110, textAlign: 'right', display: isRole?.some((role) => ["tm"].includes(role)) ? '' : 'none' }}>
                  <Tooltip title="Submit Attendance">
                    <IconButton color={popover.open ? 'inherit' : 'default'} onClick={() => {
                      setUserInfo(item);
                      attendance.onTrue();
                    }}
                      sx={{
                        display: item?.ssgenrolment?.status === 'Cancelled' ? 'none' : ''
                      }}
                    >
                      <Iconify icon="carbon:send-filled" />
                    </IconButton>
                  </Tooltip>
                </Box> */}
              </Stack>

            ))}
            {getUnSubmittedAttendance?.map((item) => {
              if (item?.ssgenrolment?.status !== "Cancelled") {
                return (
                  <Stack
                    key={item?.id}
                    direction="row"
                    alignItems="center"
                    sx={{
                      p: (theme) => theme.spacing(1.5, 2, 1.5, 1.5),
                      '&:not(:last-of-type)': {
                        borderBottom: (theme) => `solid 2px ${theme.palette.background.neutral}`,
                      },
                    }}
                  >
                    <Avatar
                      src={""}
                      variant="rounded"
                      sx={{ width: 48, height: 48, mr: 2 }}
                    />

                    <ListItemText
                      primary={item?.traineeInfo?.fullName}
                      secondary={item?.traineeInfo?.nricFin}
                      primaryTypographyProps={{
                        typography: 'body2',
                      }}
                      secondaryTypographyProps={{
                        color: 'text.disabled',
                        mt: 0.5,
                      }}
                    />

                    <Box sx={{ textAlign: 'left' }}>
                      <Label
                        variant="soft"
                        color={
                          (item?.ssgenrolment?.status === 'Confirmed' && 'success') ||
                          (item?.ssgenrolment?.status === 'Cancelled' && 'error') ||
                          (item?.ssgenrolment?.status === 'Draft' && 'warning') ||
                          'default'
                        }
                      >
                        {item?.ssgenrolment?.status === 'Confirmed' ? 'Enrolment Confirmed' : item?.ssgenrolment?.status === 'Cancelled' ? 'Enrolment Cancelled' : item?.ssgenrolment?.status}
                      </Label>
                    </Box>

                    <Box sx={{ textAlign: 'left', marginLeft: '10px', width: 175 }}>

                    </Box>


                    {/* <Box sx={{ width: 110, textAlign: 'right'}}>
                    <Tooltip title="Add Attendance">
                      <IconButton color={popover.open ? 'inherit' : 'default'} onClick={() => {
                        setUserInfo(item?.traineeInfo);
                        setSessionNo(sessionNorow);
                        eSign.onTrue()
                      }}
                      sx={{
                        display: item?.ssgenrolment?.status === 'Cancelled' ? 'none' : ''
                      }}
                      >
                          <Iconify icon="solar:pen-bold" />
                      </IconButton>
                      </Tooltip>
                  </Box> */}

                    {/* <Box sx={{ width: 110, textAlign: 'right', display: isRole?.some((role) => ["tm"].includes(role)) ? '' : 'none' }}>
                      <Tooltip title="Submit Attendance">
                        <IconButton color={popover.open ? 'inherit' : 'default'} onClick={() => {
                          setUserInfo(
                            {
                              name: item?.traineeInfo.fullName,
                              id: item?.traineeInfo.nricFin,
                              idType: {
                                code: item?.traineeInfo.idType
                              },
                              "email": item?.traineeInfo?.email,
                              "contactNumber": {
                                "countryCode": "65",
                                "areaCode": "0",
                                "mobile": item?.traineeInfo?.mobileNo
                              },

                            }
                          );
                          attendance.onTrue();
                        }}
                          sx={{
                            display: item?.ssgenrolment?.status === 'Cancelled' ? 'none' : ''
                          }}
                        >
                          <Iconify icon="carbon:send-filled" />
                        </IconButton>
                      </Tooltip>
                    </Box> */}
                  </Stack>
                )

              }
            })}
          </Stack>

        </Collapse>
      </TableCell>
    </TableRow>
  )


  return (
    <>

      {renderPrimary}
      {secondaryPrimary}
      <AttendanceDialog
        title="Add Attendance"
        open={attendance.value}
        onClose={attendance.onFalse}
        class={row}
        userInfo={trainee}
        setSurvey={setSurvey}
        surveryValue={surveryValue}
        action={
          <Button variant="outlined" color="inherit" onClick={() => handleSaveAttendance()}>
            Save
          </Button>
        }
      />
      <ESignature
        title="e-Sign"
        open={eSign.value}
        onClose={eSign.onFalse}
        setSignature={setSignature}
        action={
          <Button variant="outlined" color="inherit" onClick={() => handleESignature()}>
            Save
          </Button>
        }
      />

    </>
  )

}

ClassAttendanceRow.propTypes = {
  onViewRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSubmitAttendance: PropTypes.func,
  classinfo: PropTypes.object
};

